// extracted by mini-css-extract-plugin
export const closeNav = "Navigation-module--closeNav--1EcqD";
export const isActive = "Navigation-module--is-active--2dnCm";
export const mobileNav = "Navigation-module--mobileNav--2RFpc";
export const sidebarHead = "Navigation-module--sidebarHead--1DK87";
export const navButton = "Navigation-module--navButton--2Fc70";